import * as React from 'react';

import { useCtx } from 'one-ui-provider';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import { ScreenpopProps } from './props';
import Button from "antd/lib/button";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import {
  setAction as screenpopAction
} from 'one-state-screenpop/src/actions';
import {
  ScreenPopFrom,
  ScreenpopModel
} from 'one-state-screenpop/src/model';
import {
  ScreenpopModel as ReceiveCommModel
} from 'one-state-receive-communication/src/model';

import {
  setAction as ReceiveCommAction
} from 'one-state-receive-communication/src/actions';

/**
 * This components reads the screenpop values from settings file and constructs url
 * @param props  contains the selected/active patient ,screenpop respecite to his pages
 */
export const ScreenpopComp = (
  props: ScreenpopProps
) => {
  const {
    selected,
    ani,
    dnis
  } = props;

  const dispatch = useDispatch();

  const { agentId, settings: { screenpop, screenpop_config, compatible,epicendpoints } } = useCtx();
  const { location, nomatchid, event } = screenpop_config;
  const { contact_center_type, screenpop_type, useridtype, sso,lookuptype } = compatible;
  const {searchID} = epicendpoints;
  const { map } = screenpop;
  const epicuserid = useSelector((state:any) => (state.epicuserid));
  const genesysagentdata = useSelector((state:any)=> (state.genesysagentinfo))
/**
 * This method will intiate screen pop
 * @param activityId passed and build an object sent to epic to make request
 */
  const handleScreenPop = (activityId: string) => {
    const patientContactNumber = selected?.contact;
    let formattedPhoneNumber = patientContactNumber?.replace(/-/g,'');
    if(screenpop_type === 'snap_adapter'){
      let agentIdValue = agentId;
      if (contact_center_type && contact_center_type === 'five9') {
        //This is for Five9
        agentIdValue = sessionStorage.getItem("five9_userid");
      }
      const patientid = selected?.id
      const sobject: ScreenpopModel = {
        activityId,
        patientId: patientid ? patientid : nomatchid,
        eventType: event,
        location,
        agentId: agentIdValue,
        from: ScreenPopFrom.SLIDER_MENU
      }
      dispatch(screenpopAction(sobject));
    }
    else {
      let agentIdValue = agentId;let calldnisdata = dnis
      if (contact_center_type && contact_center_type === 'five9') {
        //This is for Five9
        agentIdValue = sessionStorage.getItem("five9_userid");
      }
      else if (contact_center_type && contact_center_type === 'vonage' ) {
        //This is for Vonage
        agentIdValue = sessionStorage.getItem("vonage_userid")
      }
      else if (contact_center_type && contact_center_type === 'inContact' ) {
        //This is for InContact
        agentIdValue = sessionStorage.getItem("inContact_userid")
      }
      else if (contact_center_type && contact_center_type === 'twilio' ) {
        //This is for Twilio
        agentIdValue = sessionStorage.getItem("twilio_userid")
      }
      else if (contact_center_type && contact_center_type === 'ringcentral' ) {
        //This is for ringcentral
        agentIdValue = sessionStorage.getItem("ringcentral_agentName")
      }
      else if(contact_center_type === "genesys") {
        //This is for Genesys
        agentIdValue = genesysagentdata
        calldnisdata = sessionStorage.getItem("genesys_dnis");
      }
      else if (contact_center_type && contact_center_type === 'wxcc' ) {
        //This is for Wxcc
        agentIdValue = epicuserid?.agentuserid;
      }
      
       if( sso === false) {
        agentIdValue = epicuserid?.agentuserid
      }
      const patientid = selected?.id
      //ADPAC-1830
      const sobject: ReceiveCommModel = {
        context: activityId,
        patientId: patientid ? patientid : "",
        agentId: agentIdValue,
        useridtype: useridtype,
        lookuptype: lookuptype,
        callId: calldnisdata,
        contactType: 'Incoming',
        communicationType: 'Phone',
        phoneNumber: formattedPhoneNumber ? formattedPhoneNumber : ani,
        type: patientid ? searchID : "",
        from: ScreenPopFrom.SLIDER_MENU
      }
      dispatch(ReceiveCommAction(sobject));
    }
  }
  /**
   *
   * @param url opens given url in new page
   */
  const popurl = (url: any) => {
    window.open(url);
  }

  const keys = map || [];
  let index = 0;
  const keyComps = [];
  while (index < keys.length) {
    const buttons = [];
    const maxCols = 2;
    for (let colIndex = 0; colIndex < maxCols; colIndex++) {
      if (index < keys.length) {
        let key = keys[index];
        buttons.push(
          <Col span={24 / maxCols} style={{ padding: '2px' }} >
            <li key={index} className="ant-drawer__item">
              <Button className="ant-btn--menu" style={{ fontSize: '1.0rem', whiteSpace: 'normal' }} size="large" block={true} onClick={
                (key.type === 'web') ?
                  (() => { popurl(key.key) }) :
                  (() => { handleScreenPop(key.key) })
              }>{key.label}</Button>
            </li>
          </Col>
        );
        index = index + 1;
      }
    }
    keyComps.push(
      <>
        <ul className="ant-drawer__menu">
          <Row>
            {buttons}
          </Row>
        </ul>
      </>
    );
  }
  return (
    <>
    {/* According to ADPAC-2536 */}
    <div className="ant-drawer__subtitle">Screen pops</div>
      {keyComps}
    </>
  );
};